if(typeof requirejs!=='undefined'){
    (function(){
        function RJSErrorStack(message,modules,parents,context){

            this.message='requirejs : ' + message;
            this.modules=modules||[];
            this.parentModules=parents;
            this.context=context||"unknown";
        };

        RJSErrorStack.prototype = new Error();

        requirejs.onError=function(err){
            if(err){
                var requireMap,
                    parentModules,
                    context;
                if(err.originalError){
                    var el=err.originalError.srcElement || err.originalError.target,
                        context=el.getAttribute('data-requirecontext'),
                        module=el.getAttribute('data-requiremodule');
                    context=context;

                    requireMap = requirejs.s.contexts[context].registry[module].map;
                }else{
                    requireMap=err.requireMap
                }
                requireMap=requireMap||err.requireMap||{};

                parentModules= requireMap && requireMap.parentMap && [].concat(requireMap.parentMap).filter(Boolean).map(function(parent){return parent && parent.id || null})|| ["unknown"];

                var rjsErrorStack = new RJSErrorStack(err.requireType,err.requireModules,parentModules,context);

                if(console && console.warn){
                    console.warn('%s%s%o%s%o%s%o',rjsErrorStack.message, "\n\tLoading : \n\t\t", rjsErrorStack.modules.join('\n\t\t'), "\n\tFrom module(s) : \n\t\t", rjsErrorStack.parentModules.join('\n\t\t'), "\n\tOriginal error : \n\t\t", err );
                    throw err;
                }
            }
        };
    })()
};
define("requirejs-better-errors/requirejs-better-errors", function(){});

